// redirections.js

export const handleRedirection = (abreviaturaUniversidade, navigate) => {

  switch (abreviaturaUniversidade) {
    case "ISPOZANGO":
      navigate.push('https://ispozls.com');
      break;
    case "FUTURISSTESTS":
      navigate.push('https://testesangola.futurissvision.com');
      break;
    case "FUTURISS":
      navigate.push('https://futurissvision.com');
      break;
    case "UCAN":
      navigate.push('https://ucansoft.net');
      break;
    case "UNIKIN":
      navigate.push('https://www.unikin.ac.cd/');
      break;
    case "LECARTESIEN":
      navigate.push('https://lecartesienrdc.com');
      break;
    case "PETISLUTINS":
      navigate.push('https://petitslutinsapp.com');
      break;
    case "IDERO":
      navigate.push('https://www.ideroapp.com');
      break;
    case "CUM":
      navigate.push('https://ucemis.academy/index.php');
      break;
    case "ISPOZANGOSEDE":
      navigate.push('https://ispozangosede.com');
      break;
    case "SIERASCHOOLS":
      navigate.push('https://sieraschools.com');
      break;
    case "ESAE":
      navigate.push('https://esae.bj');
      break;

    default:
      navigate.push("/");
      break;
  }
};